import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import LanguageSwitcher from "./LanguageSwitcher";
import { ONEGO_LOGO } from "../lib/api";
import { Menu, X } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
    const { user, logout } = useAuth();
    const { t } = useI18n();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const links = [
        { to: "#problem", label: t.nav.problem },
        { to: "#solution", label: t.nav.solution },
        { to: "#who", label: t.nav.who },
        { to: "#roadmap", label: t.nav.roadmap },
    ];

    return (
        <header className="sticky top-0 z-40 backdrop-blur bg-white/80 border-b border-slate-200/70" data-testid="site-navbar">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2" data-testid="nav-home-link">
                    <img src={ONEGO_LOGO} alt="OneGo" className="h-9 w-auto" />
                </Link>
                <nav className="hidden lg:flex items-center gap-2">
                    {links.map((l) => (
                        <a
                            key={l.to}
                            href={l.to}
                            className="px-3 py-2 text-sm font-semibold text-slate-700 hover:text-onego-navy transition-colors"
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <div className="hidden lg:flex items-center gap-2">
                    <LanguageSwitcher />
                    {user ? (
                        <>
                            <button
                                onClick={() => navigate("/dashboard")}
                                className="og-btn-ghost text-sm"
                                data-testid="nav-dashboard-btn"
                            >
                                {t.nav.dashboard}
                            </button>
                            <button onClick={async () => { await logout(); navigate("/"); }} className="og-btn-primary text-sm" data-testid="nav-logout-btn">
                                {t.nav.signout}
                            </button>
                        </>
                    ) : (
                        <>
                            <Link to="/login" className="og-btn-ghost text-sm" data-testid="nav-login-link">
                                {t.nav.signin}
                            </Link>
                            <Link to="/register" className="og-btn-gradient text-sm" data-testid="nav-register-link">
                                {t.nav.waitlist}
                            </Link>
                        </>
                    )}
                </div>
                <button
                    className="lg:hidden p-2"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Toggle menu"
                    data-testid="nav-mobile-toggle"
                >
                    {open ? <X /> : <Menu />}
                </button>
            </div>
            {open && (
                <div className="lg:hidden border-t border-slate-200 bg-white">
                    <div className="px-6 py-4 flex flex-col gap-2">
                        {links.map((l) => (
                            <a key={l.to} href={l.to} className="py-2 text-slate-700 font-semibold" onClick={() => setOpen(false)}>
                                {l.label}
                            </a>
                        ))}
                        {user ? (
                            <>
                                <button onClick={() => navigate("/dashboard")} className="og-btn-ghost text-left">
                                    Dashboard
                                </button>
                                <button onClick={async () => { await logout(); navigate("/"); }} className="og-btn-primary">
                                    Sign out
                                </button>
                            </>
                        ) : (
                            <>
                                <Link to="/login" className="og-btn-ghost text-left">Sign in</Link>
                                <Link to="/register" className="og-btn-gradient text-center">Join the waitlist</Link>
                            </>
                        )}
                    </div>
                </div>
            )}
        </header>
    );
}
